
  export const ORDENCAMBIOS_RECEIVED = "ORDENCAMBIOS_RECEIVED";
  export const SET_ORDENCAMBIO = "SET_ORDENCAMBIO";
  export const CREATE_ORDENCAMBIO = "CREATE_ORDENCAMBIO";
  export const SET_PROPERTY_ORDENCAMBIO = "SET_PROPERTY_ORDENCAMBIO";
  